import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  height: 10px;
  margin-left: 2px;
  width: calc(100% - 2px);
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
Column.displayName = 'Column';

export const Points = styled.div`
  align-items: center;
  background-color: #29fbe1;
  border: 2px solid #ffffff;
  border-right: 0;
  color: #000000;
  display: flex;
  font-size: 38px;
  font-weight: bold;
  height: 56px;
  justify-content: center;
  line-height: 56px;
  min-width: 58px;
  text-align: center;
`;
Points.displayName = 'Points';

export const TeamContainer = styled.div`
  align-items: flex-end;
  display: flex;
  height: 70px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamColor = styled.div`
  height: 10px;
  margin-left: 2px;
  width: calc(100% - 2px);
`;
TeamColor.displayName = 'TeamColor';

export const TeamName = styled.div`
  align-items: center;
  background: #201f22;
  border: 2px solid #ffffff;
  border-right: 0;
  color: #29fbe1;
  display: flex;
  font-size: 34px;
  font-style: normal;
  font-weight: normal;
  height: 56px;
  justify-content: center;
  line-height: 56px;
  min-width: 150px;
  padding: 0 16px;
  position: relative;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #201f22;
  border: 2px solid #ffffff;
  color: #ffffff;
  display: flex;
  font-size: 38px;
  font-style: normal;
  font-weight: normal;
  height: 56px;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 56px;
  min-width: 140px;
  text-align: center;
`;
Timer.displayName = 'Timer';
